const SingleLetter = (value) => {
    return (
        <span className="single-letter">
            {value}
        </span>
    );
}

export default SingleLetter;